<div class="row shadow p-4 mb-5 bg-white rounded mt-3 monitor-dashboard-chart-card">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <h5 class="mb-2 monitor-dashboard-card-title">
        <span class="monitor-dashboard-chart-title-link" @click="onTitleClick">{{ $t('monitorDashboard.requestTimeline') }}</span>
      </h5>
    </div>

    <div ref="timelineStage" class="monitor-dashboard-chart-stage monitor-dashboard-requests-timeline-stage">
      <div v-show="!isLoading && hasData" ref="timelineScroll" class="monitor-dashboard-requests-timeline-scroll"
        :style="scrollContainerStyle"
        role="region"
        :aria-label="$t('monitorDashboard.requestTimeline')">
        <div class="monitor-dashboard-requests-timeline-inner" :style="innerStyle">
          <canvas :id="canvasId"
            class="monitor-dashboard-chart-canvas monitor-dashboard-requests-timeline-canvas"
            role="img"
            :aria-label="$t('monitorDashboard.requestTimeline')"></canvas>
        </div>
      </div>

      <div v-if="isLoading" class="monitor-dashboard-skeleton-wrap" role="status" aria-live="polite">
        <span class="sr-only">{{ $t('monitorDashboard.loading') }}</span>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-block" aria-hidden="true"></div>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line" aria-hidden="true"></div>
      </div>

      <div v-else-if="!hasData" class="monitor-dashboard-state-block">
        <p class="mb-0 font-weight-bold">{{ $t('monitorDashboard.noRequestsDataFor', { chartName: $t('monitorDashboard.requestTimeline') }) }}</p>
      </div>
    </div>
  </div>
</div>
